import produce from 'immer';
import { trendGraphActions } from './actions';

const initialState = {
  data: {},
  loading: false,
  loaded: false,
  success: false,
  error: false,
  errorMessage: '',
  actionType: '',
};

const TrendGraph = (state = initialState, action) => {
  const { type: actionType, payload } = action;
  switch (actionType) {
    case trendGraphActions.CLEAN_TREND_GRAPH_DATA:
      return initialState;

    case trendGraphActions.FETCH_TREND_GRAPH_DATA:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.loaded = false;
        draft.success = false;
        draft.error = false;
        draft.errorMessage = '';
        draft.actionType = actionType;
      });
    case trendGraphActions.FETCH_TREND_GRAPH_DATA_SUCCESS:
      return produce(state, (draft) => {
        draft.data = payload.data;
        draft.loading = false;
        draft.loaded = true;
        draft.success = true;
        draft.error = false;
        draft.actionType = actionType;
      });
    case trendGraphActions.FETCH_TREND_GRAPH_DATA_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loaded = true;
        draft.success = false;
        draft.error = true;
        draft.errorMessage = payload;
        draft.actionType = actionType;
      });
    case trendGraphActions.FETCH_TREND_GRAPH_DATA_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loaded = false;
        draft.success = false;
        draft.error = false;
        draft.errorMessage = '';
        draft.actionType = actionType;
      });
    default:
      return state;
  }
};

export default TrendGraph;
